import React, { useState, useEffect } from "react";

import {
  TextField,
  Alert,
  Tooltip,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Select as MSelect,
  MenuItem,
} from "@mui/material";
import { Update, Delete } from "@mui/icons-material";
import Select, { components } from "react-select";
import apiUrl from "../api";

import axios from "axios";

const CustomOption = (props) => {
  return (
    <Tooltip
      title="color"
      placement="left"
      PopperProps={{
        style: { zIndex: 10001 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10],
            },
          },
        ],
        sx: {
          "& .MuiTooltip-tooltip": {
            fontSize: "14px",
            backgroundColor: `${props.data.tooltip}`,
            color: ` ${props.data.tooltip}`,
          },
        },
      }}
    >
      <div>
        <components.Option {...props} />
      </div>
    </Tooltip>
  );
};

const DeleteDialog = (props) => {
  const [selectedStatus, setSelectedStatus] = useState("");

  const handleStatusDelete = async (e) => {
    e.preventDefault();
    props.setError("");
    props.setSuccess("");

    // Add your API call here to delete the status
    // console.log(`Bearer ${props.user.token.toString()}`);
    try {
      const response = await axios.delete(
        `${apiUrl}/ticket-options/deleteStatusOption/${props.selectedStatus}`,
        {
          replaceStatus: selectedStatus,
          headers: {
            Authorization: `Bearer ${props.user.token}`,
          },
        }
      );

      props.setStatuses(
        props.statuses.filter((status) => status._id !== selectedStatus)
      );

      props.setSuccess("Status deleted successfully.");
      props.onClose();
    } catch (error) {
      console.log(error);
      props.setError("Failed to delete status. Please try again.");
      props.onClose();
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Status"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Select a status to replace the deleted status with.
        </DialogContentText>

        <MSelect
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          fullWidth
          sx={{
            width: "100%",
          }}
        >
          {props.statuses
            .filter((status) => status._id !== props.selectedStatus)
            .map((status) => (
              <MenuItem key={status._id} value={status._id}>
                {status.title}
              </MenuItem>
            ))}
        </MSelect>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          onClick={handleStatusDelete}
          autoFocus
          disabled={selectedStatus === ""}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UpdateStatusOption = () => {
  const [statusName, setStatusName] = useState("");
  const [statusColor, setStatusColor] = useState("#FA0808");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/ticket-options/getStatusOptions`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        setStatuses(response.data.statusOptions);
      } catch (error) {
        setError("Failed to fetch statuses. Please try again.");
      }
    };
    fetchStatuses();
  }, []);

  const handleStatusSelect = (selectedOption) => {
    setSelectedStatus(selectedOption.value);
    setStatusName(selectedOption.label);
    setStatusColor(selectedOption.tooltip);
  };

  const handleUpdateStatus = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (statusName === "") {
      return setError("Status name is required.");
    }

    // Add your API call here to update the status
    try {
      const response = await axios.put(
        `${apiUrl}/ticket-options/updateStatusOption/${selectedStatus}`,
        {
          title: statusName,
          color: statusColor,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setStatuses(
        [...statuses].map((status) => {
          if (status._id === selectedStatus) {
            return {
              ...status,
              title: statusName,
              color: statusColor,
            };
          }
          return status;
        })
      );

      setSuccess("Status updated successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Status already exists.");
      } else {
        setError("Failed to update status. Please try again.");
      }
    }
  };

  return (
    <div className="update-status-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
        Edit Status
      </h4>
      <Select
        value={selectedStatus.value}
        onChange={(selectedOption) => handleStatusSelect(selectedOption)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "var(--secondary-color)",
            primary25: "var(--tertiary-color)",
          },
        })}
        options={[
          ...statuses.map((status) => ({
            value: status._id,
            label: status.title,
            tooltip: status.color,
          })),
        ]}
        components={{ Option: CustomOption }}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 1000, // Adjust this value as needed, ensuring it is higher than the z-index of other components
          }),
        }}
      />

      {selectedStatus && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <form
            onSubmit={handleUpdateStatus}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              label="Status Name"
              placeholder="Status Name"
              value={statusName}
              onChange={(e) => setStatusName(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <TextField
              variant="outlined"
              type="color"
              label="Label Color"
              value={statusColor}
              onChange={(e) => setStatusColor(e.target.value)}
              margin="normal"
              sx={{
                width: "20%",
              }}
              // Custom styling may be required for color input to look consistent
              InputProps={{
                inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
              }}
            />
            <button
              className="add-ticket-button__button"
              sx={{
                backgroundColor: "var(--primary-color)",
                color: "var(--primary-text-color)",
                fontSize: "15px",
                fontWeight: "600",
                width: "auto",
                padding: "10px 20px",
              }}
              onClick={() => {}}
            >
              <Update />
              <span>Update</span>
            </button>
          </form>
          <button
            className="add-ticket-button__button"
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "var(--primary-text-color)",
              fontSize: "15px",
              fontWeight: "600",
              width: "auto",
              padding: "0px 20px",
            }}
            onClick={() => setDeleteDialogOpen(true)}
          >
            <Delete />
            <span>Delete</span>
          </button>
          <DeleteDialog
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            statuses={statuses}
            setStatuses={setStatuses}
            selectedStatus={selectedStatus}
            setError={setError}
            setSuccess={setSuccess}
            user={user}
          />
        </div>
      )}
    </div>
  );
};

export default UpdateStatusOption;
